<template>
  <div style="margin:20px">
    <div style="width: 100%; background-color: #eee; border: 1px dotted grey; margin-bottom: 25px;">
      <span style="font-size: 26px; font-weight: bold">Vehicle Departure Board</span><br/>
      <div style="font-style: italic; font-size: 18px; padding-bottom: 15px; margin-left: 90px; margin-right: 10px">this page shows vehicles soon to be dispatched
        <span style="float:right; font-weight: bold; font-size: 18px;"><b-btn size="sm" @click="load_data()"><span style="font-size: 16px; font-weight: bold">Reload</span></b-btn>&nbsp;&nbsp;<span @click="printPage()"><img height="30px" src="/print-icon.png"/></span></span>
      </div>
    </div>

    <br/>
    
    <div v-if="summary">
      <b-table :busy="loading" sticky-header="70vh" bordered :items="items" :fields="visibleFields"
               :current-page="currentPage" :sort-compare="tableSortCompare" :style="'font-size:' + summary.font_size + 'px'" :per-page="perPage">

        <template #table-busy>
          <div class="text-center text-danger my-2">
            <b-spinner style="width: 3rem; height: 3rem;" label="Loading..."></b-spinner>
          </div>
        </template>

        <template slot="next_mvmt_driver" slot-scope="row">
          <template v-for="mvmt_driver in row.item.next_mvmt_driver">
            {{mvmt_driver}}
          </template>
        </template>

        <template slot="next_mvmt_time" slot-scope="row">
          {{row.item.next_mvmt_time | formatDateTimeSmall}}
        </template>

        <template slot="next_mvmt_id" slot-scope="row">
          {{row.item.next_mvmt_id}}
          <template v-if="row.item.next_mvmt_list" v-for="next_mvmt in row.item.next_mvmt_list">
            <br/>{{next_mvmt.next_mvmt_id}}
          </template>
        </template>

        <template slot="next_mvmt_delta" slot-scope="row">
          <span v-if="row.item.next_mvmt_delta" :style="row.item.next_mvmt_delta.indexOf('d') != -1 ? '' : 'color: red'">
            {{row.item.next_mvmt_delta}}
          </span>
          <template v-if="row.item.next_mvmt_list" v-for="next_mvmt in row.item.next_mvmt_list">
            <br/>{{next_mvmt.next_mvmt_delta}}
          </template>
        </template>

      </b-table>
      <b-row v-if="items.length > 10">
        <b-col>
          <b-pagination
              v-model="currentPage"
              :total-rows="items.length"
              :per-page="perPage"
              align="center"
          >
          </b-pagination>
        </b-col>
      </b-row>
    </div>
    <div v-else>
      <div class="text-center text-danger my-2">
        <b-spinner style="width: 3rem; height: 3rem;" label="Loading..."></b-spinner>
      </div>
    </div>
  </div>
</template>

<script>

import {get_trip_sheet} from "../networking/apis";
import {mapState} from "vuex";
import moment from 'moment';
import datetime from 'vuejs-datetimepicker';
import {justDate} from "../helpers/dates";

export default {
  name: 'trip_sheet',
  components: {
     datetime
  },
  metaInfo: {
    title: "Fleet Integrations",
    titleTemplate: "Fleet Integrations",
  },
  data() {
    return {
      search_filter: '',
      tenant_id: null,
      updating: false,
      reloading: false,
      details_fromDate: justDate(moment()),
      items: [],
      summary: null,
      loading: true,
      totalRows: 1,
      currentPage: 1,
      perPage: 300,
      pages: [],
      alert: {
        show: false,
        message: '',
        variant: ''
      },
      options: {
        format: 'MM-DD-YYYY',
        useCurrent: true,
        minDate: moment().subtract(30, 'days'),
        maxDate: moment().add(30, 'days'),
        keepOpen: false,
        showClear: true,
        showClose: true,
        toolbarPlacement: 'top',
      },
      fields: [
        { key: 'name', label: 'Vehicle', sortable: true, visible: true, thStyle: { width: "100px" }},
        { key: 'next_mvmt_driver', label: 'Next Driver', sortable: true, visible: true, thStyle: { width: "150px" }},
        { key: 'next_mvmt_id', label: 'Next Booking', sortable: true, visible: true, thStyle: { width: "120px" }},
        { key: 'next_mvmt_time', label:'Next Start', sortable: true, visible: true, thStyle: { width: "140px" }},
        { key: 'next_mvmt_client_ref1', label:'Customer', sortable: true, visible: true, thStyle: { width: "20px" }},
        { key: 'next_mvmt_delta', label:'Departs In', sortable: true, visible: true, thStyle: { width: "100px" }},
        { key: 'current_location', label:'Current Location', sortable: true, visible: true, thStyle: { width: "300px" }},
        { key: 'next_mvmt_pickup', label:'Pickup', sortable: true, visible: true, thStyle: { width: "300px" }},
        { key: 'next_mvmt_destination', label:'Destination', sortable: true, visible: true, thStyle: { width: "300px" }},
      ],
    }
  },
  async created() {
    this.tenant_id = this.user.tenant
    this.fields_all = this.fields
    await this.check_features()
  },
  beforeDestroy() {
    clearInterval(this.timer)
  },
  methods: {
    printPage() {
      window.print();
    },
    showAlert(msg, variant, autoclose) {
      this.alert.show = true
      this.alert.message = msg
      this.alert.variant = variant
      autoclose
          ? setTimeout(() => this.closeAlert(), autoclose)
          : null
    },
    closeAlert() {
      this.alert.show = false
      this.alert.message = ''
      this.alert.variant = ''
    },
    tableSortCompare(aRow, bRow, key) {
      if (key == 'next_mvmt_delta') {
        return aRow['next_mvmt_ms'] - bRow['next_mvmt_ms']
      }
      return false;
    },
    async check_features() {
      this.fields = this.fields_all
      this.load_data()
    },
    async load_data() {
      this.loading = true
      try {
        var results = await get_trip_sheet(this.tenant_id, moment(this.details_fromDate, 'MM-DD-YYYY').format('YYYY-MM-DD'))
        const {value: { data = [] } } = results

        this.summary = data.summary
        moment.tz.setDefault(this.summary.timezone)
        this.items = data.results

      } catch(e) {
        this.$emit('showAlert', 'error retrieving data, try logging in again or contact support if needed', 'danger', 5000)
      }

      this.loading = false
    },
    async reload_data() {
      try {
        if (this.updating)
          return;

        this.reloading = true

        var results = await get_trip_sheet(this.tenant_id, moment(this.details_fromDate, 'MM-DD-YYYY').format('YYYY-MM-DD'))
        const {value: { data = [] } } = results

        this.summary = data.summary
        moment.tz.setDefault(this.summary.timezone)
        this.items = data.results
      } catch(e) {
        this.$emit('showAlert', 'error retrieving data, try logging in again or contact support if needed', 'danger', 5000)
      }

      this.reloading = false
    },
    contains(val1, val2) {
      if (val1 != null) {
        return val1.toLowerCase().indexOf(val2.toLowerCase()) != -1;
      }
      return false;
    },
    get_row_color(item) {
      if (item) {
        if (item.vehicle_status)
          return item.vehicle_status.toLowerCase()
        else
          return "unknown";
      }
    },
    get_history_row_color(item) {
      return "unknown";
    },
},
  computed:{
    ...mapState({
      user: state => state.profile.user
    }),
    visibleFields() {
      var custom_fields = null;

      if (this.summary && this.summary.visible_fields)
        custom_fields = this.summary.visible_fields;

      if (custom_fields != null) {
        let new_fields = []
        for (let visible_field of custom_fields.split(",")) {
          let found_field = this.fields_all.filter(field => visible_field == field.key)
          if (found_field.length > 0) {
            new_fields.push(found_field[0]);
          }
        }
        return new_fields;
      } else
        return this.fields.filter(field => field.visible)
    }
  },
  watch: {
    user: {
      deep: true,
      handler() {
        this.check_features()
      }
    },
  }
}
</script>

<style scoped>
.total { border: 1px solid grey; border-radius: 5px; padding: 2px; margin:2px}

div.row:nth-child(even) {
  background-color: #f2f2f2;
}

tr:nth-child(even) {
  background-color: #f2f2f2;
}

.header {
  font-weight: bold;
}

div.col {
  border: 1px solid grey;
}

.table td {
  padding: .1rem !important;
}

.mvmt-table td {
  vertical-align: middle !important;
}

div.wrap {
  border: 1px solid grey;
  flex-wrap: wrap;
  display: flex;
  inline-size: 150px;
  /* overflow-wrap: break-word; */
}

.stats { border-radius: 5px; margin:2px}
</style>

